import { useService } from 'react-reservice';

import { getUseServiceWithSubscriptionKeys } from '@webtrader/core/utils';

import notificationsService from './service';

export const useNotifications = () => {
  return useService(notificationsService, (state) => state);
};

export const useNotificationsWithKeys = getUseServiceWithSubscriptionKeys(notificationsService);

export { notificationsService };
